import React, { useCallback, useEffect, useRef, useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { SectionTitle } from './SectionTitle';
import { OFFER_ANCHOR, previewImages } from '../data/salesCopy';
export function PreviewSection() {
  const trackRef = useRef<HTMLUListElement>(null);
  const [active, setActive] = useState(0);
  const scrollTo = useCallback((index: number) => {
    const track = trackRef.current;
    if (!track) return;
    const slide = track.children[index] as HTMLElement | undefined;
    if (slide) {
      track.scrollTo({
        left: slide.offsetLeft,
        behavior: 'smooth'
      });
    }
  }, []);
  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;
    const onScroll = () => {
      const width = track.clientWidth || 1;
      setActive(Math.round(track.scrollLeft / width));
    };
    track.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => track.removeEventListener('scroll', onScroll);
  }, []);
  const go = (dir: -1 | 1) => {
    const next = Math.min(previewImages.length - 1, Math.max(0, active + dir));
    setActive(next);
    scrollTo(next);
  };
  return <section className="bg-brand-sand px-4 py-8 sm:py-10" data-id="element-120" data-mp="27v98vpvzwxqk">
      <div className="mx-auto max-w-4xl" data-id="element-121" data-mp="2lreftdrvq5x0">
        <SectionTitle data-id="element-122" data-mp="2lqblevvcllcc">Aperçu du matériel</SectionTitle>
        <p className="mt-3 text-center font-serif text-xl font-bold text-brand-brown sm:text-2xl" data-id="element-123" data-mp="2guwbgf0go9l7">
          Découvrez l’intérieur de YIN YOGA PRO™
        </p>
        <p className="mx-auto mt-1.5 max-w-2xl text-center text-[12.5px] font-medium leading-snug text-brand-brown/85 sm:text-sm" data-id="element-124" data-mp="1p2oxjmccbbai">
          Explorez les postures visuelles, séquences structurées, variations,
          adaptations, ressources thématiques, modèles de préparation et outils
          prêts à utiliser inclus dans le système complet.
        </p>

        <div className="relative mt-4" data-id="element-125" data-mp="1abptmomg9ax9">
          <ul ref={trackRef} className="no-scrollbar flex snap-x snap-mandatory gap-3 overflow-x-auto scroll-smooth" data-id="element-126" data-mp="15epn6clou65m">
            {previewImages.map(img => <li key={img.src} className="w-full shrink-0 snap-start" data-id="element-127" data-mp="3afiflqo0d2c6">
                <a href={OFFER_ANCHOR} className="block" data-id="element-128" data-mp="3f68q1ibajvdq">
                  <img src={img.src} alt={img.alt} loading="lazy" className="w-full rounded-lg border border-brand-taupe/30 bg-white shadow-[0_10px_26px_-14px_rgba(64,54,47,0.6)]" data-id="element-129" data-mp="3f8uwtfqcy6uw" />
                </a>
              </li>)}
          </ul>

          <button type="button" onClick={() => go(-1)} disabled={active === 0} aria-label="Image précédente" className="absolute left-1 top-1/2 flex h-9 w-9 -translate-y-1/2 items-center justify-center rounded-full border border-brand-taupe/30 bg-white/95 text-brand-brown shadow-md transition-opacity duration-150 ease-smooth disabled:opacity-30" data-id="element-130" data-mp="2wexwsui3f6io">
            <ChevronLeftIcon className="h-5 w-5" data-id="element-131" data-mp="208w7qmdsxhzn" />
          </button>
          <button type="button" onClick={() => go(1)} disabled={active === previewImages.length - 1} aria-label="Image suivante" className="absolute right-1 top-1/2 flex h-9 w-9 -translate-y-1/2 items-center justify-center rounded-full border border-brand-taupe/30 bg-white/95 text-brand-brown shadow-md transition-opacity duration-150 ease-smooth disabled:opacity-30" data-id="element-132" data-mp="1w7kkuombbav5">
            <ChevronRightIcon className="h-5 w-5" data-id="element-133" data-mp="1clxxw7k6t8ap" />
          </button>
        </div>

        <div className="mt-3 flex items-center justify-center gap-2" data-id="element-134" data-mp="18irs110zlj4r">
          {previewImages.map((img, i) => <button key={img.src} type="button" onClick={() => {
          setActive(i);
          scrollTo(i);
        }} aria-label={`Voir l’image ${i + 1} sur ${previewImages.length}`} aria-current={i === active} className={`h-2 rounded-full transition-[width,background-color] duration-150 ease-smooth ${i === active ? 'w-6 bg-brand-brown' : 'w-2 bg-brand-taupe/50'}`} data-id="element-135" data-mp="13l85zey1s229" data-mpi={i} />)}
        </div>
      </div>
    </section>;
}